@if (appliedFields$ | async; as appliedFields) {
  @if (appliedFields?.length > 0) {
    <mat-chip-listbox class="applied-filters-bar">
      @for (field of appliedFields; track field) {
        <mat-chip-option>
          {{ field.label | translate }}
          <mat-icon matChipRemove (click)="clearValue(field)">cancel</mat-icon>
        </mat-chip-option>
      }
    </mat-chip-listbox>
  }
}
